<div class="container-fluid" dir="rtl">
  <div *ngIf="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status"><span class="visually-hidden">در حال بارگذاری...</span></div>
    <p class="mt-2">در حال بارگذاری اطلاعات فعالیت ماهانه خدمات...</p>
  </div>
  <div *ngIf="error && !isLoading" class="alert alert-danger text-center" role="alert">
    <i class="fas fa-exclamation-triangle me-2"></i>{{ error }}
    <button type="button" class="btn btn-outline-danger btn-sm ms-3" (click)="goBack()">بازگشت</button>
  </div>
  <div *ngIf="reportData && !isLoading" class="services-industry-monthly-activity-detail">
    <div class="header-section card mb-4">
      <div class="card-header bg-info text-white">
        <h4 class="mb-0"><i class="fas fa-concierge-bell me-2"></i>جزئیات فعالیت ماهانه خدمات</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <p><strong>نماد:</strong> {{ reportData.symbol }} <span *ngIf="reportData.isin">({{ reportData.isin }})</span></p>
            <p><strong>عنوان شرکت:</strong> {{ reportData.title }}</p>
          </div>
          <div class="col-md-6">
            <p><strong>سال مالی:</strong> {{ reportData.fiscalYear | persianNumber }}</p>
            <p *ngIf="reportData.reportMonth"><strong>ماه گزارش:</strong> {{ reportData.reportMonth | persianNumber }}</p>
          </div>
        </div>
        <div class="row mt-2" *ngIf="reportData.uri">
          <div class="col-12">
            <a [href]="reportData.uri" target="_blank" class="btn btn-sm btn-outline-primary">
              <i class="fas fa-external-link-alt me-1"></i>مشاهده در سامانه کدال
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="section-card card mb-4" *ngIf="reportData.items?.length">
      <div class="card-header bg-primary text-white">
        <h5 class="mb-0"><i class="fas fa-list me-2"></i>اقلام فعالیت ماهانه</h5>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm" style="font-size: 0.85rem;">
            <thead class="table-dark">
              <tr>
                <th>شرح خدمات</th>
                <th>تاریخ شروع</th>
                <th>مدت (ماه)</th>
                <th class="text-end">درآمد از ابتدای سال</th>
                <th class="text-end">درآمد اصلاح‌شده</th>
                <th class="text-end">درآمد ماهانه</th>
                <th class="text-end">درآمد انباشته</th>
                <th class="text-end">درآمد سال قبل</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of reportData.items"
                [ngClass]="{'table-secondary fw-bold': item.rowCode && item.rowCode !== -1}">
                <td>{{ item.serviceDescription }}</td>
                <td>{{ item.contractStartDate || '' }}</td>
                <td>{{ item.contractDurationMonths || '' }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.yearToDateRevenue))" tooltipClass="tooltip-class">{{ formatNumber(item.yearToDateRevenue) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.correctedYearToDateRevenue))" tooltipClass="tooltip-class">{{ formatNumber(item.correctedYearToDateRevenue) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.monthlyRevenue))" tooltipClass="tooltip-class">{{ formatNumber(item.monthlyRevenue) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.cumulativeToPeriodRevenue))" tooltipClass="tooltip-class">{{ formatNumber(item.cumulativeToPeriodRevenue) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.previousYearRevenue))" tooltipClass="tooltip-class">{{ formatNumber(item.previousYearRevenue) }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="mt-3 mb-4">
      <button type="button" class="btn btn-secondary" (click)="goBack()">
        <i class="fas fa-arrow-right me-2"></i>بازگشت به لیست
      </button>
    </div>
  </div>
</div>
